<script>
import ElRow from 'element-ui/packages/row/src/row'

export default {
  extends: ElRow,
  props: {
    gutter: {
      type: Number,
      default: 20
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/common/components/element/ElRow.vue